import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CreateGoodsIssueReceiptContainer from 'app/containers/InventoryManagement/WarehouseGoodsIssueReceipt'

const CreateGoodsIssueReceiptContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <CreateGoodsIssueReceiptContainer />
    </>
  )
}
const CreateGoodsIssueReceiptContainerPage = memo(
  CreateGoodsIssueReceiptContainerPageCpn,
  isEqual,
)

export default CreateGoodsIssueReceiptContainerPage
